// components/FreeExamModal.jsx
import React from "react";
import "./FreeExamModal.css";

const FreeExamModal = ({ visible, onClose, onTryNow }) => {
  if (!visible) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="modal-close" onClick={onClose}>
          &times;
        </button>
        <h2>🎉 Try Our Free Examination!</h2>
        <p>
          We're excited to introduce a new feature in BeyondSchools! Take a free
          exam to test your knowledge and see how you perform.
        </p>
        <div className="modal-actions">
          <button className="btn-primary" onClick={onTryNow}>
            Try Now
          </button>
          <button className="btn-secondary" onClick={onClose}>
            Maybe Later
          </button>
        </div>
      </div>
    </div>
  );
};

export default FreeExamModal;
